import React from 'react';
import I18n from 'i18n-js';
import { buttonClassName } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { CartClickInteraction } from '@reverbdotcom/commons/src/elog/mparticle_types';
import {
  core_apimessages_CheckoutPaymentMethod_Type as CheckoutPaymentMethodType,
} from '../schemas/rql';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import { useTrackCheckoutClickEvent } from './checkout/checkoutTracking';
import experiments from '@reverbdotcom/commons/src/experiments';

interface Props {
  paymentMethodType: CheckoutPaymentMethodType;
  checkoutPath: string;
}

export default function CartStartCheckoutButton(props: Props) {
  const trackEvent = useTrackCheckoutClickEvent(
    {
      id: null,
      paymentMethod: {
        type: props.paymentMethodType,
      },
    },
  );

  function button() {
    return (
      <CoreLink
        to={props.checkoutPath}
        className={buttonClassName({ variant: 'primary', fullWidth: true })}
        onClick={() => trackEvent(CartClickInteraction.StartCheckout)}
      >
        <ButtonContent />
      </CoreLink>
    );
  }

  return (
    <div className="mobile-width-100">
      {button()}
    </div>
  );
}

function ButtonContent() {
  const buttonText = I18n.t('discovery.checkout.cart.startCheckout');
  const inCheckoutArrowExp = useExpEnabled(experiments.CART_CHECKOUT_BUTTON);

  return (
    <>
      {buttonText}
      {inCheckoutArrowExp &&
        <span className="icon-r-arrow-right" />
      }
    </>
  );
}
